module.exports = __webpack_public_path__ + "f7234308b78dcdd82e20d69c22ba137b.png";